export interface IReservationsPublicUrlInput {
  baseUrl: string;
  stringId: string;
  branchId?: number | null;
  branchCount?: number;
}

export function buildReservationsPublicUrl(
  input: IReservationsPublicUrlInput
): string {
  const url = new URL(
    `${input.baseUrl.replace(/\/+$/, '')}/${encodeURIComponent(
      input.stringId
    )}/reservations`
  );
  if ((input.branchCount ?? 1) > 1 && input.branchId != null)
    url.searchParams.set('b', String(input.branchId));
  return url.toString();
}
